import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CarServices from '../../services/CarServices';
import CategoryServices from '../../services/CategoryServices';
import ReactQuill from 'react-quill';

function ServiceUpdate({ service, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        vendorId: '',
        category: '',
        subCategory: '',
        title: '',
        description: '',
        sequence:"",
        mobileNo: '',
        logo: '',
        images: [],
        address: '',
        state: '',
        cityName: '',
        latitude: '',
        longitude: '',
        openTime: '',      
        closeTime: '',
        terms: '',
        socialLinks: {
            instagram: '',
            facebook: '',
            website: ''
        }
    });

    const [categories, setCategories] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [logoPreview, setLogoPreview] = useState('');
    const [uploadingImages, setUploadingImages] = useState(false);
    const [uploadingLogo, setUploadingLogo] = useState(false);
    const [loadingCities, setLoadingCities] = useState(false);

    // Fetch categories
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await CategoryServices.getCategoryActive();
                if (res.status) {
                    setCategories(res.data);
                }
            } catch (error) {
                console.error('Error fetching categories', error);
            }
        };
        fetchCategories();
    }, []);

    // Fetch vendors
    useEffect(() => {
        CarServices.getVendorActive().then(res => {
            if (res.status) setVendors(res.data);
        });
    }, []);

    // Fetch states
    useEffect(() => {
        CarServices.getState().then(res => {
            if (res.status) setStates(res.data);
        });
    }, []);

    // Fetch cities when state changes
    useEffect(() => {
        const fetchCities = async () => {
            if (formValues.state) {
                setLoadingCities(true);
                try {
                    const res = await CarServices.getCities(formValues.state);
                    if (res.status) {
                        setCities(res.data);
                    } else {
                        setCities([]);
                    }
                } catch (error) {
                    console.error('Error fetching cities:', error);
                    setCities([]);
                } finally {
                    setLoadingCities(false);
                }
            } else {
                setCities([]);
            }
        };
        fetchCities();
    }, [formValues.state]);


    const formatTime = (timeStr) => {
        if (!timeStr) return '';

        // Already correct format
        if (timeStr.includes(':') && !timeStr.includes('AM') && !timeStr.includes('PM')) {
            return timeStr;
        }

        // Convert "10.15 AM" -> "10:15"
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split('.');

        if (modifier === 'PM' && hours !== '12') {
            hours = String(parseInt(hours) + 12);
        }
        if (modifier === 'AM' && hours === '12') {
            hours = '00';
        }

        return `${hours.padStart(2, '0')}:${minutes}`;
    };
    useEffect(() => {
        const stateId = service?.state?._id || service?.state || '';
        const cityId = service?.cityName?._id || service?.cityName || '';
        const longitude = service?.location?.coordinates?.[0] || '';
        const latitude = service?.location?.coordinates?.[1] || '';

        if (service) {
            setFormValues({
                vendorId: service?.vendorId?._id || service?.vendorId || '',
                category: service?.category?._id || '',
                subCategory: service?.subCategory?._id || '',
                title: service?.title || '',
                description: service?.description || '',
                mobileNo: service?.mobileNo || '',
                sequence: service?.sequence || '',
                logo: service?.logo || '',
                images: service?.images || [],
                address: service?.address || '',
                // state: service?.state?._id || service?.state || '',
                // cityName: service?.cityName?._id || service?.cityName || '',
                state: stateId,
                cityName: '',
                // latitude: service?.latitude || '',
                // longitude: service?.longitude || '',
                latitude: latitude,
                longitude: longitude,
                openTime: formatTime(service?.openTime),
                closeTime: formatTime(service?.closeTime),
                terms: service?.terms || '',
                socialLinks: {
                    instagram: service?.socialLinks?.instagram || '',
                    facebook: service?.socialLinks?.facebook || '',
                    website: service?.socialLinks?.website || ''
                }
            });
            setTimeout(() => {
                setFormValues(prev => ({
                    ...prev,
                    cityName: cityId
                }));
            }, 0);
            // Set previews for existing images
            if (service.images && service.images.length > 0) {
                setPreviewImages(service.images);
            }

            // Set logo preview
            if (service.logo) {
                setLogoPreview(service.logo);
            }

            // Fetch subcategories for the initial category
            if (service?.category?._id) {
                fetchSubcategories(service.category._id);
            }
        }
    }, [service]);

    const fetchSubcategories = async (categoryId) => {
        try {
            const res = await CategoryServices.getSubCategoryByCategory(categoryId);
            if (res.status && Array.isArray(res.data)) {
                // setSubCategories(res.data);
                const subcats = res.data[0]?.subcategory || [];
                setSubCategories(subcats);
                setFormValues(prev => ({
                    ...prev,
                    subCategory: subcats.length > 0 ? subcats[0]._id : ''
                }));

            } else {
                setSubCategories([]);
            }
        } catch (error) {
            console.error('Error fetching subcategories', error);
            setSubCategories([]);
        }
    };

    const handleQuillChange = (name, value) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value
        }));
    };

    const handleInputChange = async (event) => {
        const { name, value } = event.target;

        if (name === 'category') {
            setFormValues(prev => ({
                ...prev,
                category: value,
                subCategory: '',
            }));

            if (value) {
                try {
                    const res = await CategoryServices.getSubCategoryByCategory(value);
                    if (res.status && Array.isArray(res.data)) {
                        // setSubCategories(res.data);
                        const subcats = res.data[0]?.subcategory || [];
                        setSubCategories(subcats);
                        setFormValues(prev => ({
                            ...prev,
                            subCategory: subcats.length > 0 ? subcats[0]._id : ''
                        }));
                    } else {
                        setSubCategories([]);
                    }
                } catch {
                    setSubCategories([]);
                }
            } else {
                setSubCategories([]);
            }
            return;
        }

        if (name === 'state') {
            setFormValues(prev => ({
                ...prev,
                state: value,
                cityName: '' // Reset city when state changes
            }));
            return;
        }

        setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
    };

    const handleSocialChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            socialLinks: {
                ...prev.socialLinks,
                [name]: value
            }
        }));
    };

    // Logo upload handler
    const handleLogoChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploadingLogo(true);
        const formData = new FormData();
        formData.append('images', file);

        try {
            const res = await CarServices.uploadImage(formData);
            if (res.images?.length) {
                setFormValues(prev => ({ ...prev, logo: res.images[0] }));
                setLogoPreview(res.images[0]);
            }
        } catch (error) {
            console.error('Logo upload error:', error);
            alert('Failed to upload logo');
        } finally {
            setUploadingLogo(false);
        }
    };

    // Multiple images upload handler
    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        const validFormats = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
        const filteredFiles = files.filter((file) => validFormats.includes(file.type));

        if (filteredFiles.length === 0) {
            alert("Please upload valid image files (png, jpeg, jpg, webp).");
            return;
        }

        setUploadingImages(true);
        try {
            const formData = new FormData();
            filteredFiles.forEach((file) => formData.append('images', file));
            const response = await CarServices.uploadImage(formData);
            if (response && Array.isArray(response.images)) {
                const uploadedImages = response.images.map((imagePath) => {
                    const normalizedPath = imagePath.replace(/\\/g, '/');
                    return `${normalizedPath}`;
                });
                setFormValues((prevValues) => ({
                    ...prevValues,
                    images: [...prevValues.images, ...uploadedImages],
                }));
                setPreviewImages((prevPreviews) => [...prevPreviews, ...uploadedImages]);
            } else {
                console.error('Unexpected response format:', response);
                throw new Error('Image upload failed: Invalid response format');
            }
        } catch (error) {
            console.error('Image upload failed', error);
            alert('Failed to upload images. Please try again.');
        } finally {
            setUploadingImages(false);
            event.target.value = null;
        }
    };

    // Remove image handler
    const handleRemoveImage = async (imageUrl) => {
        try {
            const response = await CarServices.removeImage({ url: imageUrl });
            if (response.status) {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    images: prevValues.images.filter((image) => image !== imageUrl),
                }));
                setPreviewImages((prevPreviews) => prevPreviews.filter((image) => image !== imageUrl));
                alert('Image removed successfully!');
            } else {
                alert('Failed to remove image from server');
            }
        } catch (error) {
            console.error('Failed to remove image', error);
            alert('Failed to remove image');
        }
    };

    // Remove logo handler
    const removeLogo = () => {
        setFormValues(prev => ({ ...prev, logo: '' }));
        setLogoPreview('');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validation
        if (!formValues.vendorId) {
            alert('Please select a vendor');
            return;
        }
        if (!formValues.category) {
            alert('Please select a category');
            return;
        }
        if (!formValues.subCategory) {
            alert('Please select a sub category');
            return;
        }
        if (!formValues.title) {
            alert('Please enter a title');
            return;
        }
        if (!formValues.mobileNo) {
            alert('Please enter mobile number');
            return;
        }
        if (!formValues.address) {
            alert('Please enter address');
            return;
        }
        if (!formValues.state) {
            alert('Please select a state');
            return;
        }
        if (!formValues.cityName) {
            alert('Please select a city');
            return;
        }
        if (!formValues.openTime) {
            alert('Please select open time');
            return;
        }

        if (!formValues.closeTime) {
            alert('Please select close time');
            return;
        }
        if (formValues.openTime >= formValues.closeTime) {
            alert("Close time must be greater than open time");
            return;
        }

        try {
            const payload = {
                ...formValues,
            };
            const response = await CarServices.updateService(service._id, payload);
            if (response.status) {
                alert('Service updated successfully');
                onSuccess();
                closeModal();
            } else {
                alert('Failed to update service');
            }
        } catch (error) {
            console.error('Failed to update service:', error);
            alert('Error updating service');
        }
    };

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Shop</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner table-reponsive-tabe">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className='row'>
                                            {/* Vendor */}
                                            <div className='col-lg-6 col-sm-6'>
                                                <div className="input-field">
                                                    <label>Owner</label>
                                                    <select
                                                        name="vendorId"
                                                        className="form-control"
                                                        value={formValues.vendorId}
                                                        onChange={handleInputChange}                                                       
                                                    >
                                                        <option value="">Select Owner</option>
                                                        {vendors.map(v => (
                                                            <option key={v._id} value={v._id}>{v.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Category */}
                                            <div className='col-lg-6 col-sm-6'>
                                                <div className="input-field">
                                                    <label>Category*</label>
                                                    <select
                                                        name="category"
                                                        className="form-control"
                                                        value={formValues.category}
                                                        onChange={handleInputChange}
                                                        
                                                    >
                                                        <option value="">Select a category</option>
                                                        {categories.map((category) => (
                                                            <option key={category?._id} value={category?._id}>
                                                                {category?.title}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Sub Category */}
                                            <div className='col-lg-6'>
                                                <div className="input-field">
                                                    <label>Sub Category*</label>
                                                    <select
                                                        name="subCategory"
                                                        className="form-control"
                                                        value={formValues.subCategory}
                                                        onChange={handleInputChange}
                                                        disabled={!formValues.category}
                                                        
                                                    >
                                                        <option value="">Select Sub Category</option>
                                                        {subCategories.map(sub => (
                                                            <option key={sub._id} value={sub._id}>{sub.title}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Title */}
                                            <div className='col-lg-6'>
                                                <div className="input-field">
                                                    <label>Title*</label>
                                                    <input
                                                        type="text"
                                                        name="title"
                                                        value={formValues.title}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        
                                                    />
                                                </div>
                                            </div>

                                            {/* Mobile Number */}
                                            <div className='col-lg-6'>
                                                <div className="input-field">
                                                    <label>Mobile No*</label>
                                                    <input
                                                        type="text"
                                                        name="mobileNo"
                                                        value={formValues.mobileNo}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        
                                                        placeholder="Mobile No"
                                                    />
                                                </div>
                                            </div>

                                            {/* Logo */}
                                            <div className="col-lg-6">
                                                <div className="input-field">
                                                    <label>Logo (Single Image)</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        onChange={handleLogoChange}
                                                        disabled={uploadingLogo}
                                                        accept="image/*"
                                                    />
                                                    {uploadingLogo && <p className="text-muted mt-1">Uploading...</p>}
                                                    {logoPreview && (
                                                        <div className="mt-2 position-relative d-inline-block">
                                                            <img
                                                                src={`${process.env.REACT_APP_URL}${logoPreview}`}
                                                                width="80"
                                                                height="80"
                                                                style={{ objectFit: 'cover', borderRadius: '4px' }}
                                                                alt="Logo preview"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={removeLogo}
                                                                className="btn btn-danger btn-sm"
                                                                style={{ position: 'absolute', top: '-8px', right: '-8px', borderRadius: '50%', padding: '2px 6px' }}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Multiple Images */}
                                            <div className="col-lg-6">
                                                <div className="input-field">
                                                    <label>Images (Multiple)</label>
                                                    <input
                                                        type="file"
                                                        multiple
                                                        className="form-control"
                                                        onChange={handleFileChange}
                                                        disabled={uploadingImages}
                                                        accept="image/*"
                                                    />
                                                    {uploadingImages && <p className="text-muted mt-1">Uploading images...</p>}
                                                    <p>Supported formats: png, jpeg, jpg, webp</p>
                                                    <div className="image-preview-container-service" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
                                                        {previewImages.map((image, index) => (
                                                            <div key={index} className="preview-image position-relative d-inline-block">
                                                                <img
                                                                    src={process.env.REACT_APP_URL + image}
                                                                    alt={`Preview ${index}`}
                                                                    width="80"
                                                                    height="80"
                                                                    style={{ objectFit: 'cover', borderRadius: '4px' }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() => handleRemoveImage(image)}
                                                                    style={{ position: 'absolute', top: '-8px', right: '-8px', borderRadius: '50%', padding: '2px 6px' }}
                                                                >
                                                                    ×
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Address */}
                                            <div className='col-lg-12'>
                                                <div className="input-field">
                                                    <label>Address*</label>
                                                    <input
                                                        type="text"
                                                        name="address"
                                                        value={formValues.address}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        
                                                        placeholder="Address"
                                                    />
                                                </div>
                                            </div>

                                            {/* State */}
                                            <div className='col-lg-6'>
                                                <div className="input-field">
                                                    <label>State*</label>
                                                    <select
                                                        name="state"
                                                        className="form-control"
                                                        value={formValues.state}
                                                        onChange={handleInputChange}
                                                        
                                                    >
                                                        <option value="">Select State</option>
                                                        {states.map(state => (
                                                            <option key={state._id} value={state._id}>{state.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* City */}
                                            <div className='col-lg-6'>
                                                <div className="input-field">
                                                    <label>City*</label>
                                                    <select
                                                        name="cityName"
                                                        className="form-control"
                                                        value={formValues.cityName}
                                                        onChange={handleInputChange}
                                                        
                                                        disabled={!formValues.state || loadingCities}
                                                    >
                                                        <option value="">{loadingCities ? "Loading cities..." : "Select City"}</option>
                                                        {cities.map(city => (
                                                            <option key={city._id} value={city._id}>{city.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Latitude */}
                                            <div className='col-lg-3'>
                                                <div className="input-field">
                                                    <label>Latitude</label>
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        name="latitude"
                                                        value={formValues.latitude}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        placeholder="Latitude"
                                                    />
                                                </div>
                                            </div>

                                            {/* Longitude */}
                                            <div className='col-lg-3'>
                                                <div className="input-field">
                                                    <label>Longitude</label>
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        name="longitude"
                                                        value={formValues.longitude}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        placeholder="Longitude"
                                                    />
                                                </div>
                                            </div>
                                            {/* Open Time */}
                                            <div className='col-lg-3'>
                                                <div className="input-field">
                                                    <label>Open Time*</label>
                                                    <input
                                                        type="time"
                                                        name="openTime"
                                                        value={formValues.openTime}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        
                                                    />
                                                </div>
                                            </div>

                                            {/* Close Time */}
                                            <div className='col-lg-3'>
                                                <div className="input-field">
                                                    <label>Close Time*</label>
                                                    <input
                                                        type="time"
                                                        name="closeTime"
                                                        value={formValues.closeTime}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        
                                                    />
                                                </div>
                                            </div>

                                            {/* Description */}
                                            <div className='col-lg-12'>
                                               
                                                    <label>Description</label>
                                                    <textarea
                                                        name="description"
                                                        value={formValues.description}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        rows="4"
                                                        placeholder="Description"
                                                    />
                                                </div>

                                            {/* Social Links */}
                                            <div className="col-lg-12 mt-3">
                                                <label>Social Links</label>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="input-field">
                                                    <input
                                                        className="form-control"
                                                        name="instagram"
                                                        placeholder="Instagram URL"
                                                        value={formValues.socialLinks.instagram}
                                                        onChange={handleSocialChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="input-field">
                                                    <input
                                                        className="form-control"
                                                        name="facebook"
                                                        placeholder="Facebook URL"
                                                        value={formValues.socialLinks.facebook}
                                                        onChange={handleSocialChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="input-field">
                                                    <input
                                                        className="form-control"
                                                        name="website"
                                                        placeholder="Website URL"
                                                        value={formValues.socialLinks.website}
                                                        onChange={handleSocialChange}
                                                    />
                                                </div>
                                            </div>
  <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Select Sequence</label>
                          <select className="form-control" value={formValues.sequence} onChange={handleInputChange} name="sequence">
                            <option value="1">1</option>
    <option value="2">2</option>
    <option value="3">3</option>
    <option value="4">4</option>
    <option value="5">5</option>
    <option value="6">6</option>
    <option value="7">7</option>
    <option value="8">8</option>
    <option value="9">9</option>
    <option value="10">10</option>
    <option value="11">11</option>
    <option value="12">12</option>
    <option value="13">13</option>
    <option value="14">14</option>
    <option value="15">15</option>
    <option value="16">16</option>
    <option value="17">17</option>
    <option value="18">18</option>
    <option value="19">19</option>
    <option value="20">20</option>
    <option value="21">21</option>
    <option value="22">22</option>
    <option value="23">23</option>
    <option value="24">24</option>
    <option value="25">25</option>
    <option value="26">26</option>
    <option value="27">27</option>
    <option value="28">28</option>
    <option value="29">29</option>
    <option value="30">30</option>
    <option value="31">31</option>
    <option value="32">32</option>
    <option value="33">33</option>
    <option value="34">34</option>
    <option value="35">35</option>
    <option value="36">36</option>
    <option value="37">37</option>
    <option value="38">38</option>
    <option value="39">39</option>
    <option value="40">40</option>
                          </select>
                        </div>
                      </div>
                                         

                                        </div>
                                        <button className="submit-green-btn mt-4" type="submit">UPDATE</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceUpdate;